import { useEffect, useState } from "react";
import { useTheme } from "styled-components";
import { clearCurrentActorGroup, clearSaveComplete } from "../../../../store/actions/actorGroupActions";
import { ActorSearchResult } from "../../../../store/model/searchModel";
import { roleSelectionSelector } from "../../../../store/selectors/searchSelectors";
import { useAppDispatch, useAppSelector } from "../../../../store/store";

import Button from "react-bootstrap/Button";

import Form from "react-bootstrap/Form";

import Modal from "react-bootstrap/Modal";


import CenteredModal from "../../CenteredModal";
import ActorCard from "./ActorCard";
import {
    currentActorGroupDataLoading,
    saveCompleteSelector,    
} from "../../../../store/selectors/actorGroupSelector";
import LoadingSpinner from "../../../../assets/components/LoadingSpinner";
import { ActorGroupDetail } from "../../../../store/model/actorGroupModel";
import { loggedInUserSelector } from "../../../../store/selectors/authSelector";
import SaveRoleDialog from "./SaveRoleDialog";







interface EditRolesProps {
    handleActorClick: (actor: ActorSearchResult) => void;
    switchPane: () => void;
    currentActorGroup: ActorGroupDetail | null; 
}

const EditRoles: React.FC<EditRolesProps> = ({ handleActorClick, currentActorGroup}) => {
    const dispatch = useAppDispatch();
    const theme = useTheme();
    const roleSelections = useAppSelector((state: RootState) => roleSelectionSelector(state));
    const saveComplete = useAppSelector(saveCompleteSelector);
    const user = useAppSelector(loggedInUserSelector);
    const currentActorGroupLoading = useAppSelector(currentActorGroupDataLoading)

    const [showSave, setShowSave] = useState<boolean>(false);    

    const [showExport, setShowExport] = useState<boolean>(false);    
    
    

    const handleModalClose = () => {           
        setShowSave(false);
    };
    

    const showSaveModal = () => {       
        setShowSave(true);
    }
     

    const handleCancelClick = () => {
        dispatch(clearCurrentActorGroup());
    }      

    useEffect(() => {
        if (saveComplete) {                        
            dispatch(clearSaveComplete());
            handleModalClose();
        }
    }, [dispatch, saveComplete]); 

    return (
        <div
            className="selection-container w-100"
            style={{ display: "flex", flexWrap: "wrap", gap: "0.5rem", paddingBottom: "5rem" }}
        >
            {roleSelections &&
                roleSelections.map((actor) => {
                    return (
                        <ActorCard
                            key={actor.actorId}
                            actor={actor}
                            displayMode="selection"
                            onClick={(e) => handleActorClick(actor)}
                            customStyle={{
                                width: "calc(33% - (1rem / 3))",
                                [theme.breakpoints.down("lg")]: {
                                    width: "calc(20% - (2rem / 5))"
                                },
                                [theme.breakpoints.down("md")]: {
                                    width: "calc(25% - (1.5rem / 4))"
                                },
                                [theme.breakpoints.down("sm")]: {
                                    width: "calc(33.3% - (1rem / 3))"
                                }

                            }}
                        />
                    );
                })}
            
            {currentActorGroup && currentActorGroupLoading &&
                <div className="w-100 d-flex justify-content-center p-5">
                    <LoadingSpinner style={{ width: "4rem", height: "4rem"}}/>
                </div>
            }
            <div style={{ position: "absolute", bottom: "2rem", background: theme.palette.background.default, padding: "0.5rem", borderRadius: "15px" }}>
                {user?.role !== "User" &&  <>
                    {roleSelections !== null && roleSelections.length > 0 &&
                        <Button                        
                            onClick={(e) => showSaveModal()}
                            disabled={!roleSelections || roleSelections.length === 0}
                            style={{color: "white"}}
                        >
                            Save
                        </Button>
                    }
                    
                    {currentActorGroup !== null && 
                        <Button variant="link" 
                            style={{ marginLeft: "0.5rem"}}
                            onClick={(e) => handleCancelClick()}
                        >
                            Cancel
                        </Button>
                    }
                    
                    </>      
                }
                {user?.role === "User" && 
                    <Button 
                        onClick={(e) => setShowExport(true)}
                        disabled={roleSelections === null || roleSelections.length === 0}
                        style={{ color: "#FFF"}}
                    >
                        Export
                    </Button>                            
                }
            </div>            
            

            
             <SaveRoleDialog show={showSave} handleModalClose={handleModalClose} defaultIndex={currentActorGroup !== null ? 1 : 0} currentActorGroup={currentActorGroup} />
            
             <CenteredModal
                    show={showExport}
                    onHide={() => setShowExport(false)}
                    vCenter={true}
                    title="Actor List"
                >
                    <Modal.Body>
                        <Form.Control
                            as="textarea">
                            {roleSelections?.map(x => x.firstName + " " + x.lastName).join("\n")}
                        </Form.Control>
                    </Modal.Body>                  
                </CenteredModal>
        </div>
    );
};

export default EditRoles;
